<app-common-grid [GridColumns]="gridColumns" [pageName]="'Reg Sho'" [exceptionCode]="'0003'"></app-common-grid>